<template>
  <empty-card
    :mainText="$t('page.paymentLinks.createACheckoutPageInstantly')"
    :buttonText="$t('page.paymentLinks.createPaymentLink')"
    :buttonColor="'primary'"
    buttonIcon="mdi-plus"
    @button-click="handleCreate"
  >
    <template #image>
      <v-img
        src="@/shared/assets/payment_link.png"
        max-height="150px"
        min-height="75px"
      /> </template
  ></empty-card>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";
import EmptyCard from "@/shared/components/Common/EmptyCard.vue";
const router = useRouter();
const handleCreate = () => {
  router.push({ name: "createPaymentLink" });
};
</script>
